import React from 'react';
import { faTags } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TagRegularIconProps {
  className?: string;
}

function TagRegularIcon(props: TagRegularIconProps) {
  return <FontAwesomeIcon icon={faTags} {...props} />;
}

export default TagRegularIcon;
